import * as React from 'react';
import PropTypes from 'prop-types';
import '../../assets/styles/header.css';
import { useMediaQuery, Box, AppBar, CssBaseline, Divider, Drawer, IconButton, List, ListItem, ListItemButton, ListItemText, Toolbar, Typography, Button } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import setting from '../../setting.json';
const drawerWidth = setting.Header.MenuSize;
const navItems = setting.Header.SubContent.Choices;

function Header(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const brake = useMediaQuery("(min-width:900px)");

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Typography id='dela-gothic-one-regular' variant={setting.Header.MainContent.Size} sx={{ my: 2 }}>
        {setting.Header.MainContent.Text}
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton component="a" href={item.uri} id='dotgothic16-regular' sx={{ textAlign: 'center' }}>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <div>
      <CssBaseline />
      <AppBar component="nav" style={{ color: setting.Header.MainContent.Color, backgroundColor: setting.Header.MainContent.BackColor }}>
        <Toolbar>
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          {!brake || <img src={setting.Header.MainIcon} alt="mainicon" width="50" height="50" />}
          <Typography
            variant={setting.Header.MainContent.Size}
            component="div"
            id='dela-gothic-one-regular'
            sx={{ flexGrow: 1, display: { xs: 'none', md: 'block' }, margin: 3 }}
          >
            {setting.Header.MainContent.Text}
          </Typography>
          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            {navItems.map(item => (
              <Button component="a" href={item.uri} id='dotgothic16-regular' key={item.text} sx={{ color: setting.Header.SubContent.Color, fontSize: setting.Header.SubContent.Size }}>
                {item.text}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </div >
  );
}

Header.propTypes = {
  window: PropTypes.func,
};

export default Header;
